import { VALID_PROPERTY_USE_VALUES } from "js/constants/property-use";
import { FormData } from "./types";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isPropertySelectionValid = (formData: FormData): boolean => {
  const hasProperty = Boolean(formData.property && formData.property !== "");
  const hasValidPropertyUse =
    Boolean(formData.propertyUse && formData.propertyUse !== "") &&
    VALID_PROPERTY_USE_VALUES.includes(formData.propertyUse);
  // Require a finite, positive number — a lone "." (or NaN) must not pass, otherwise
  // parseFloat on submit yields NaN → rental_price: null and the backend rejects it.
  const rentValue = Number.parseFloat(formData.rentAmount ?? "");
  const hasRentAmount = Number.isFinite(rentValue) && rentValue > 0;

  return hasProperty && hasValidPropertyUse && hasRentAmount;
};

export const isTenantSelectionValid = (formData: FormData): boolean => {
  const hasTenant = Boolean(formData.tenant && formData.tenant !== "");
  const webCheckAnswered = typeof formData.webCheckRequired === "boolean";
  return hasTenant && webCheckAnswered;
};

export const isGuarantorConfigurationValid = (formData: FormData): boolean => {
  if (!formData.requiresGuarantor) {
    return true;
  }

  if (!formData.creditInvestigation) {
    return true;
  }

  const hasRequiredNames =
    Boolean(formData.guarantorName?.trim()) &&
    Boolean(formData.guarantorFirstSurname?.trim());

  const hasValidEmail =
    Boolean(formData.guarantorEmail?.trim()) &&
    EMAIL_REGEX.test(formData.guarantorEmail.trim());

  const hasValidPhone =
    Boolean(formData.guarantorPhoneNumber?.trim()) &&
    formData.guarantorPhoneNumber.trim().length === 10;

  return hasRequiredNames && hasValidEmail && hasValidPhone;
};

export const isLegalProtectionStepValid = (formData: FormData): boolean => {
  const blindajeAnswered = formData.alternativeJustice !== null;
  if (!blindajeAnswered) {
    return false;
  }

  if (formData.alternativeJustice) {
    const premiumAnswered = formData.rentInsurance !== null;
    if (!premiumAnswered) {
      return false;
    }
  }

  return formData.tenantPaysApplication !== null;
};
